import { eurosPerMonthCapMsg, t } from '../../common/i18n/index.js';
import { eurosToCents, formatSumToString } from '../../common/utils/priceUtils.js';
import type { CocoProductOrderDetail } from '../../generated/api/cocoProductOrderDetail.js';
import type { CocoProductOrderLineItem } from '../../generated/api/cocoProductOrderLineItem.js';
import type { CocoProductOrderPrice } from '../../generated/api/cocoProductOrderPrice.js';

export interface OrderContentCoCoProps {
  order: CocoProductOrderDetail;
}

export const formatPrice = (price: CocoProductOrderPrice) => formatSumToString(eurosToCents(price.priceWithoutTax));

export const getPriceTotal = (prices: CocoProductOrderPrice[], priceType: string): number | undefined => {
  const matchingPrices = prices.filter(price => price.priceType === priceType);
  return matchingPrices.length > 0
    ? matchingPrices.reduce((total, price) => total + price.priceWithoutTax, 0)
    : undefined;
};

export const getOrderItemPriceTotal = (item: CocoProductOrderLineItem, priceType: string): number | undefined => {
  const ownTotal = getPriceTotal(item.price, priceType);
  const childTotals =
    item.productOrderItem
      ?.map(childItem => getOrderItemPriceTotal(childItem, priceType))
      .filter((total): total is number => total !== undefined) ?? [];
  const totals = [...(ownTotal === undefined ? [] : [ownTotal]), ...childTotals];

  return totals.length > 0 ? totals.reduce((total, value) => total + value, 0) : undefined;
};

export const formatPriceAmount = (amount?: number) =>
  amount === undefined ? '—' : formatSumToString(eurosToCents(amount));

export const formatMonthlyPriceAmount = (amount?: number) =>
  amount === undefined ? '—' : `${formatSumToString(eurosToCents(amount), true)} ${t.H37G(eurosPerMonthCapMsg)}`;

export const getValue = (value?: object) => {
  if (value && 'value' in value && typeof value.value === 'string') {
    return value.value;
  }
  return undefined;
};
